import React from "react";

import { Alert, Box, Button, Paper, Stack, Typography } from "@mui/material";

import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

import ConsultationDocuments from "components/consultation/call/ConsultationDocuments";
import ChatComponent from "pages/appointmentByAdmin/ChatComponent/ChatComponent";

const PatientPostConsultation = ({
  canReturnToCall = true,

  rejoinChecking = false,
  postCallError = "",

  documents = [],
  documentsLoading = false,
  documentsError = "",

  appointmentId,

  onReturnToCall,
  onLeaveConsultation,
  onRefreshDocuments,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        boxSizing: "border-box",
        p: {
          xs: 1.5,
          sm: 2,
        },
      }}
    >
      <Paper
        sx={{
          width: "100%",
          maxWidth: 760,
          mx: "auto",

          p: {
            xs: 2,
            sm: 3,
          },

          borderRadius: 3,
        }}
      >
        <Stack spacing={2.5}>
          <Box>
            <Typography variant="h5" fontWeight={700}>
              Consultation Call Closed
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.5,
              }}
            >
              You have left the call. You can return while consultation access
              is still available.
            </Typography>
          </Box>

          {postCallError && <Alert severity="error">{postCallError}</Alert>}

          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={1.5}
          >
            {canReturnToCall && (
              <Button
                variant="contained"
                startIcon={<CallOutlinedIcon />}
                disabled={rejoinChecking}
                onClick={onReturnToCall}
                fullWidth
              >
                {rejoinChecking ? "Checking..." : "Go Back to Call"}
              </Button>
            )}

            <Button
              variant="outlined"
              sx={{
                color: "white",
                borderColor: "#f7687b",
                backgroundColor: "#f7687b",
                "&:hover": {
                  backgroundColor: "#ad2424", // Background color on hover
                  color: "white",
                  borderColor: "#ad2424", // Text color on hover
                },
              }}
              startIcon={<ExitToAppOutlinedIcon />}
              onClick={onLeaveConsultation}
              fullWidth
            >
              Leave Consultation
            </Button>
          </Stack>

          <Box
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              backgroundColor: "#cfffbc",
              p: {
                xs: 1.5,
                sm: 2,
              },
            }}
          >
            <Stack spacing={1.5}>
              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}
                spacing={1}
                alignItems={{
                  xs: "stretch",
                  sm: "center",
                }}
                justifyContent="space-between"
              >
                <Box>
                  <Typography variant="subtitle1" fontWeight={700}>
                    Reports & Documents
                  </Typography>

                  <Typography variant="caption" color="text.secondary">
                    Reports or documents added during the consultation will
                    appear here.
                  </Typography>
                </Box>

                <Button
                  size="small"
                  variant="text"
                  startIcon={<RefreshOutlinedIcon />}
                  disabled={documentsLoading}
                  onClick={onRefreshDocuments}
                >
                  {documentsLoading ? "Refreshing..." : "Refresh"}
                </Button>
              </Stack>

              {documentsError && (
                <Alert severity="error">{documentsError}</Alert>
              )}

              {documentsLoading ? (
                <Typography variant="body2" color="text.secondary">
                  Checking for updated documents...
                </Typography>
              ) : (
                <>
                  {/* <ConsultationDocuments
                  attachments={documents}
                /> */}
                  <ChatComponent aptId={appointmentId} />
                </>
              )}
            </Stack>
          </Box>

          <Alert severity="info">
            Leaving this screen does not automatically mark the appointment as
            completed.
          </Alert>
        </Stack>
      </Paper>
    </Box>
  );
};

export default PatientPostConsultation;
